export enum KeapEmailTemplateType { Transactional= 0, NonTransactional = 1 };
